import { BadgeStatus, Nav } from "@deere/fuel-react";
import React, { useState, useMemo, useEffect } from "react";
import "./styles.css";
import { useTranslation } from "../../common/translation-context";

function CalculationNav({ countPerPage, getActivePage, initialActiveItem }) {
  const [activeItem, setActiveItem] = useState(initialActiveItem || "bp_check"); 

  useEffect(() => {
    if (initialActiveItem) {
      setActiveItem(initialActiveItem);
    }
  }, [initialActiveItem]);
  const { translate: t } = useTranslation();

  const handleOnClick = (item) => {
    setActiveItem(item);
    getActivePage(item);
  };

  const allocateCount = (tabName) => {
    const count = countPerPage?.[`${tabName === "bp_check" ? "bpCheck" : tabName}Count`];
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "1em" }}>
        {count && count > 0 ? (
          <BadgeStatus
            anchorOrigin={{ horizontal: "left" }}
            content={count}
            style={{ marginLeft: "16px", marginRight: "4px" }}
          />
        ) : null
        }
        {t(tabName)}
      </div>
    );
  };

  const calculationNavItems = useMemo(() => [
    { label: allocateCount("bp_check"), selected: activeItem === "bp_check", onClick: () => handleOnClick("bp_check"), className: activeItem === "bp_check" ? "navbar-item-white" : "" },
    { label: allocateCount("include"), selected: activeItem === "include", onClick: () => handleOnClick("include"), className: activeItem === "include" ? "navbar-item-white" : "" },
    { label: allocateCount("exclude"), selected: activeItem === "exclude", onClick: () => handleOnClick("exclude"), className: activeItem === "exclude" ? "navbar-item-white" : "" },
    { label: allocateCount("logs"), selected: activeItem === "logs", onClick: () => handleOnClick("logs"), className: activeItem === "logs" ? "navbar-item-white" : "" },
  ], [activeItem, countPerPage, t]);

  return <Nav items={calculationNavItems} className="navbar" />;
}

export default CalculationNav;